// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Df6W4","requiredAsterisk":"Info_requiredAsterisk__CCOhW"};